// FR (vouvoiement)
export const propCreateHc = {
  firstCreate: {
    // Types de logement
    typeApartmentLabel: `Appartement`,
    typeApartmentDesc: `Logement meublé et indépendant loué en entier.`,
    typeVillaLabel: `Villa ou maison`,
    typeVillaDesc: `Maisons, villas et chalets loués en entier.`,
    typeHotelLabel: `Hôtel, auberge ou B&B`,
    typeHotelDesc: `Établissements qui gèrent plusieurs chambres.`,
    typeCampingLabel: `Camping`,
    typeCampingDesc: `Campings et emplacements avec plusieurs places ou unités.`,

    // Noms d'établissement / unité
    venueHotel: `hôtel`,
    venueCamping: `camping`,
    roomHotel: `chambre`,
    roomCamping: `emplacement`,
    roomHotelPlural: `chambres`,
    roomCampingPlural: `emplacements`,
    yourVenue: `votre {venue}`,

    // Boutons communs
    back: `Retour`,
    continue: `Continuer`,

    // Étape : type
    typeTitle: `Enregistrons votre logement !`,
    typeSubtitle: `Pour commencer, choisissez le type de logement que vous souhaitez publier.`,

    // Étape : quantité
    quantityTitle: `Combien de logements souhaitez-vous enregistrer ?`,
    quantitySubtitle: `Vous pouvez commencer par un seul ou en créer plusieurs à la fois.`,
    oneTitle: `1 logement`,
    oneDesc: `Je veux publier un seul logement pour l'instant.`,
    manyTitle: `Plus d'1 logement`,
    manyDesc: `J'en ai plusieurs à enregistrer.`,

    // Étape : emplacement (même bâtiment ou non)
    locationTitle: `Sont-ils dans le même bâtiment ou à la même adresse ?`,
    locationSubtitle: `Cela nous aide à organiser vos logements de la meilleure façon.`,
    sameBuildingYesTitle: `Oui, dans le même bâtiment ou à la même adresse`,
    sameBuildingYesDesc: `Ils seront regroupés dans une seule annonce comportant plusieurs unités.`,
    sameBuildingNoTitle: `Non, à des adresses différentes`,
    sameBuildingNoDesc: `Chacun sera une annonce indépendante (vous le configurez ensuite).`,

    // Étape : noms (titres et sous-titres dynamiques)
    namesTitleAttach: `Ajoutez une unité à votre annonce`,
    namesTitleHotel: `Comment s'appelle votre {venue} ?`,
    namesTitleGrouped: `Nommez chaque unité`,
    namesTitleList: `Nommez chaque logement`,
    namesTitleDefault: `Comment s'appelle votre logement ?`,
    namesSubAttach: `Elle sera ajoutée comme une nouvelle unité au sein de « {name} ».`,
    yourListing: `votre annonce`,
    namesSubHotel: `C'est le nom que verront vos hôtes. À l'étape suivante, vous ajoutez les types de {room}.`,
    namesSubGrouped: `Chaque unité aura son propre calendrier au sein de la même annonce.`,
    namesSubList: `Chacun sera une annonce indépendante avec sa propre configuration.`,
    namesSubDefault: `C'est le nom que verront vos hôtes. Vous pourrez le modifier quand vous voulez.`,
    addUnitLabel: `Ajouter une autre unité`,
    addListingLabel: `Ajouter un autre logement`,

    // Carte de l'annonce principale (groupée)
    mainListingEyebrow: `Annonce principale`,
    mainListingSub: `Regroupe toutes les unités de ce bâtiment dans une seule annonce.`,
    mainListingNameLabel: `Nom du logement principal`,
    mainListingNamePlaceholder: `Ex : Residencial Bilbao`,
    mainListingNameHint: `Bâtiment, tour ou emplacement qui regroupe les unités.`,
    currency: `Devise`,
    currencyHintUnit: `Tarif par nuit de chaque unité.`,

    // Cartes d'unité
    unitNameLabel: `Nom de l'unité`,
    listingNameLabel: `Nom du logement`,
    phRoomCamping: `Ex : Camping Pinar del Mar`,
    phRoomHotel: `Ex : Hôtel Costa Azul`,
    phAttach: `Ex : Studio de luxe à Playa Roca, front de mer`,
    phGrouped: `Ex : Appartement {n}A`,
    phList: `Logement {n}`,
    phDefault: `Ex : Appartement Centre-ville`,
    remove: `Retirer`,
    internalNameOptional: `Nom interne (facultatif)`,
    pricePerNight: `Prix / nuit`,
    currencyHintHotel: `Toutes les {rooms} utilisent cette devise.`,

    // Nom interne (cas d'un nom unique)
    internalNameLabel: `Nom interne`,
    optional: `(facultatif)`,
    internalNamePlaceholderSingle: `Ex : Appart rénové 2024 / clés à la conciergerie`,
    internalNameHint: `Vous seul le voyez, pour l'identifier en interne. Il n'est pas montré aux hôtes.`,

    // Étape : types de chambre (hôtel/camping)
    roomsTitle: `Quelles {rooms} possède {venue} ?`,
    roomsSubtitle: `Ajoutez chaque type de {room} avec sa quantité et son prix par nuit. Vous pourrez le modifier quand vous voulez.`,
    roomTypeLabel: `Type de {room}`,
    phRoomTypeCamping: `Ex : Emplacement avec électricité`,
    phRoomTypeHotel: `Ex : Chambre double deluxe`,
    quantity: `Quantité`,
    addRoomType: `Ajouter un type de {room}`,

    // Étape : adresse
    addressTitle: `Où se trouve votre logement ?`,
    addressSubtitle: `Commencez à saisir et choisissez l'adresse. Nous l'utilisons pour la carte et l'enregistrement.`,
    country: `Pays`,
    countryHint: `Nous ne rechercherons des adresses qu'au sein de ce pays.`,
    address: `Adresse`,
    addressPlaceholder: `Rue, numéro, ville…`,
    addressPlaceholderNoCountry: `Choisissez d'abord le pays`,
    city: `Ville`,
    zipCode: `Code postal`,

    // Étape : tarif
    priceTitle: `Votre tarif standard par nuit`,
    priceSubtitle: `C'est votre prix de base. Vous pourrez ensuite l'ajuster par saison ou par canal.`,
    priceLabel: `Prix par nuit`,
    perNight: `/ nuit`,
    priceHint: `Vous pouvez le modifier quand vous voulez depuis le tableau de bord.`,

    // Bouton principal et motif de création
    createUnit: `Ajouter une unité`,
    createVenue: `Créer mon {venue}`,
    createListingsPlural: `Créer mon logement | Créer mes {count} logements`,
    reasonUnit: `unité`,
    reasonListing: `annonce`,

    // Toasts / validation
    toastCompleteToContinue: `Complétez les informations pour continuer.`,
    toastCompleteNames: `Complétez le nom de chaque logement.`,
    toastCompleteLocation: `Complétez l'emplacement.`,
    toastCompleteRooms: `Complétez chaque chambre : nom, quantité et prix par nuit.`,
    toastRoomRatePerUnit: `Indiquez le tarif par nuit de chaque unité.`,
    toastCompleteRate: `Complétez le tarif par nuit.`,
    toastCreatedPlural: `Logement créé ! | Logements créés !`,
    toastCreateError: `Nous n'avons pas pu créer le logement. Réessayez.`,
  },

  welcome: {
    // Titres d'en-tête
    arrivalTitleCaps: `Instructions d'Arrivée`,
    arrivalTitle: `Instructions d'arrivée`,
    arrivalSubtitle: `Message que l'hôte reçoit le jour de son arrivée.`,
    welcomeTitle: `Message de bienvenue`,
    welcomeSubtitle: `Message que l'hôte reçoit après avoir terminé son enregistrement.`,
    loadingMessages: `Chargement des messages...`,

    // Bienvenue par chambre
    roomWelcomeTitle: `Message de bienvenue de cette chambre`,
    roomWelcomeSub: `Si vous le laissez vide, le message de bienvenue général de l'hôtel est envoyé. L'interrupteur, les pièces jointes et l'OTA se configurent au niveau de l'hôtel.`,

    // Interrupteur de bienvenue
    welcomeEnableTitle: `Envoyer le message de bienvenue`,
    welcomeEnableSub: `L'hôte le reçoit après avoir terminé son enregistrement. Si vous le désactivez, il ne sera pas envoyé.`,

    // Cloner
    clone: `Cloner`,
    clonePullTitle: `Importer la configuration d'un autre logement`,
    clonePullSub: `Importez la bienvenue d'un autre vers celui-ci`,
    clonePushTitle: `Copier cette configuration vers un autre logement`,
    clonePushSub: `Appliquez cette bienvenue à d'autres`,
    cloneModalPullTitle: `Importer la configuration de bienvenue`,
    cloneModalPushTitle: `Copier le message de bienvenue`,
    cloneModalPullSubtitle: `Choisissez le logement dont vous voulez importer la configuration. Elle sera appliquée à cette annonce.`,
    cloneModalPushSubtitle: `Copiez cette configuration (textes, mode, OTA et pièces jointes) vers les logements que vous choisissez.`,
    itemNounWelcome: `le message de bienvenue`,
    arrivalTitleNoun: `instructions d'arrivée`,
    itemNounArrival: `les instructions d'arrivée`,

    // Mode de configuration
    modeConfigLabel: `Mode de configuration`,
    modeSingleTitle: `Message unique`,
    modeSingleDesc: `Toutes les unités partagent le même message`,
    modeActive: `Actif`,
    modePropertyTitle: `Par propriété`,
    modePropertyDesc: `Chaque unité a son propre message`,
    modePropertyNotice: `Mode individuel actif. Modifiez le message depuis chaque propriété.`,

    // Interrupteur d'arrivée
    arrivalEnableTitle: `Envoyer les instructions d'arrivée`,
    arrivalAutoSend: `Elles sont envoyées automatiquement le jour de l'arrivée{atTime}.`,
    arrivalAtTime: ` à {time}`,

    // Canaux / envoi
    deliveryChannels: `Canaux d'envoi`,
    channelEmail: `E-mail`,
    sendAlsoOta: `Envoyer aussi par OTA`,
    sendTime: `Heure d'envoi`,

    // Éditeur
    editorSubtitle: `Configurez par langue. Astuce : utilisez des emojis et un texte court.`,
    translateTitle: `Traduire depuis {lang} vers les autres langues`,
    translatingLangLabel: `Traduction de {lang}…`,
    translatingGeneric: `Traduction…`,
    translate: `Traduire`,

    // Pièces jointes
    uploading: `Envoi en cours…`,
    attach: `Joindre`,
    emojis: `Emojis`,
    variables: `Variables`,
    variablesHint: `Cliquez pour les insérer. Elles sont remplacées par les données réelles de la réservation à l'envoi.`,
    uploadDone: `Envoyé. Enregistrement sur le serveur…`,
    uploadSizeProgress: `{done} sur {total} Mo`,
    attachHint: `Images et PDF jusqu'à {fileMb} Mo · Vidéos en MP4 jusqu'à {videoMb} Mo.`,
    whatsappLimits: `Ce sont les limites autorisées par WhatsApp.`,
    openFile: `Ouvrir {name}`,
    attachmentFallback: `pièce jointe`,
    delete: `Supprimer`,
    open: `Ouvrir`,
    arrivalAttachments: `Pièces jointes des instructions d'arrivée`,
    welcomeAttachments: `Pièces jointes du message de bienvenue`,
    attachHintFull: `Images et PDF jusqu'à {fileMb} Mo · vidéos en MP4 jusqu'à {videoMb} Mo. Ce sont les limites autorisées par WhatsApp.`,
    noAttachments: `Aucune pièce jointe pour l'instant.`,
    editorSubtitleProperty: `Configurez par langue et joignez des fichiers (images, PDF, vidéo).`,

    // Enregistrer
    saveData: `Enregistrer les données`,
    saving: `Enregistrement…`,

    // Récapitulatif des serrures
    locksConfigured: `Serrures configurées`,
    accessMethodConfigured: `Méthode d'accès configurée`,
    guestAccess: `Accès de l'hôte`,
    accessDisabledHtml: `L'envoi des codes d'accès est <strong>désactivé</strong>, il ne sera pas inclus dans les instructions d'arrivée.`,
    noAccessMethod: `Aucune méthode d'accès n'est encore configurée pour ce logement.`,
    locksHint: `Cela se configure dans la carte « Serrures et accès » de l'annonce.`,

    // Aperçu
    online: `en ligne`,
    previewDayArrival: `Jour d'arrivée`,
    previewAfterRegister: `Après l'enregistrement`,
    previewPlaceholder: `Rédigez le message pour voir l'aperçu ici…`,
    previewIncludesAccess: `Inclut l'accès configuré`,
    languageLabel: `langue {lang}`,
    previewFallbackName: `Votre logement`,
    previewFallbackAccommodation: `votre logement`,

    // Récapitulatifs de serrure (computed)
    lockNoteDynamic: `Une nouvelle clé est générée automatiquement pour chaque réservation`,
    lockTagBox: `Code de la boîte à clés`,
    lockTag: `Code`,
    lockCodePending: `Code à configurer`,
    lockCodeValue: `{tag} : {code}`,
    lockLabelDefault: `Entrée`,

    // Messages d'accès de l'aperçu (computed)
    lockMsgDynamic: `🔒🔑 *{label} · {name}*\n\nVotre code d'accès est : *58117*\n\nValable pendant votre séjour.`,
    lockMsgBox: `🔑 *{label} · {name}*\n\nLa boîte à clés s'ouvre avec le code : *{code}*\n\nÀ l'intérieur, vous trouverez les clés du logement. Merci de les remettre en partant.`,
    lockMsgStatic: `🔒🔑 *{label} · {name}*\n\nLe code de la serrure est : *{code}*\n\nUtilisez-le pour ouvrir la porte du logement.`,

    // Libellés des variables (computed)
    varGuestName: `Nom de l'hôte`,
    varFullName: `Nom complet`,
    varCheckinDate: `Date d'arrivée`,
    varCheckoutDate: `Date de départ`,
    varCheckinTime: `Heure d'arrivée`,
    varCheckoutTime: `Heure de départ`,
    varNights: `Nombre de nuits`,
    varGuests: `Nombre d'hôtes`,

    // Options de serrure (computed)
    lockOptBoxTitle: `Boîte à clés`,
    lockOptBoxDesc: `Les clés sont dans une boîte à clés sécurisée.`,
    lockOptDynamicTitle: `Serrure connectée`,
    lockOptDynamicDesc: `Chaque réservation crée une nouvelle clé automatiquement.`,
    lockOptStaticTitle: `Serrure à code fixe`,
    lockOptStaticDesc: `Une boîte à clés ou une serrure à code fixe.`,

    // Message d'arrivée par défaut (computed)
    defaultArrivalMessage: `🏡 *Instructions d'arrivée*\n\nBonjour *{guest}* 👋\n\nÀ votre arrivée, dirigez-vous vers l'entrée principale du logement. 🔑\n\nSi vous avez besoin d'aide, écrivez-nous sur ce même WhatsApp 📲\n\nBon séjour ! ✨`,

    // Contexte propriété (hérité)
    inheritedChannelsTitle: `Canaux hérités du listing`,
    inheritedListingPrefix: `Cette propriété utilise le welcome centralisé du listing`,
    emailChannel: `Courrier électronique`,
    otaActive: `OTA active`,
    inheritedNote: `Si vous voulez modifier l'envoi par OTA de ce welcome, faites-le depuis les paramètres de l'annonce/listing.`,
    propertyDeliveryTitle: `Par où ce welcome sera-t-il envoyé ?`,
    propertyDeliverySubtitle: `Configurez les canaux d'envoi pour cette propriété.`,
    propertyDeliveryNote: `Ces canaux restent actifs par défaut. Ici, vous pouvez aussi ajouter l'envoi par OTA pour cette propriété.`,
    otaRowTitle: `Envoyer les messages de bienvenue via les OTA`,
    otaRowText: `Il tentera d'envoyer le welcome de cette propriété via Booking.com et Airbnb à l'aide de Channex, avec ses pièces jointes configurées.`,
    otaRowHint: `Il est enregistré avec le message et les pièces jointes de bienvenue.`,

    // Toasts / validation
    toastLoadError: `Impossible de charger les messages.`,
    toastOtaUpdated: `Canal OTA mis à jour avec succès`,
    toastOtaError: `Impossible de mettre à jour l'envoi par OTA`,
    toastSendTimeUpdated: `Heure d'envoi mise à jour`,
    toastSendTimeError: `Impossible d'enregistrer l'heure`,
    toastArrivalEnabled: `Instructions d'arrivée activées`,
    toastArrivalDisabled: `Instructions d'arrivée désactivées`,
    toastStatusError: `Impossible de mettre à jour l'état`,
    toastWelcomeEnabled: `Message de bienvenue activé`,
    toastWelcomeDisabled: `Message de bienvenue désactivé`,
    toastModeUpdated: `Mode mis à jour avec succès`,
    toastModeError: `Impossible de mettre à jour le mode`,
    toastAttachUploaded: `Pièce(s) jointe(s) envoyée(s) avec succès`,
    toastAttachUploadError: `Erreur lors de l'envoi des pièces jointes`,
    toastAttachDeleted: `Pièce jointe supprimée`,
    toastAttachDeleteError: `Impossible de supprimer la pièce jointe`,
    toastChangesSaved: `Modifications enregistrées`,
    toastTranslateEmpty: `Rédigez un message dans la langue active avant de traduire.`,
    toastTranslateSuccess: `{count} langues traduites ! Vérifiez chaque onglet avant d'enregistrer.`,
    toastTranslatePartial: `{success} traduites, {failed} ont échoué. Vous pouvez réessayer.`,
    toastTranslateNone: `Aucune langue n'a pu être traduite. Réessayez.`,

    // Erreurs de validation des fichiers (WhatsApp)
    fileErrorVideoFormat: `❌ {name} est une vidéo {ext} et WhatsApp n'accepte que le MP4. Convertissez-la en MP4 et renvoyez-la.`,
    fileErrorTooBig: `❌ {name} pèse {mb} Mo et le maximum est de {limMb} Mo. `,
    fileErrorTooBigVideo: `WhatsApp n'accepte pas de vidéos plus grandes : compressez-la ou raccourcissez-la.`,
    fileErrorTooBigFile: `WhatsApp n'accepte pas de fichiers plus grands.`,
  },
};
